export default __webpack_public_path__ + "static/media/profile.5bc12a3a.png";